import { calculateAgeInMonths } from "./getAge";

export function getAgeGroupFromDOB(dobInput) {
  // const ageGroups = {
  //   A: "0-7 days",
  //   B: "8 days - 3 months",
  //   C: ">3 months - 6 months",
  //   D: ">6 months - 9 months",
  //   E: ">9 months - 12 months",
  //   F: ">12 months - 18 months",
  //   G: ">18 months - 24 months",
  //   H: ">24 months - 30 months",
  //   I: ">30 months - 36 months",
  //   J: ">36 months (not mapped to a group)",
  // };

  // Convert DOB string to Date object
  const dob = new Date(dobInput);
  const today = new Date();

  if (isNaN(dob.getTime())) {
    return "Invalid date input";
  }

  // Calculate age in milliseconds, days, and months
  const ageInMilliseconds = today - dob;
  const ageInDays = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24));
  const ageInMonths = calculateAgeInMonths(dobInput);

  // Determine the age group
  if (ageInDays <= 7) {
    return "A"; // 0-7 days
  } else if (ageInDays <= 90) { // 8 days - 3 months
    return "B";
  } else if (ageInMonths <= 6) {
    return "C"; // >3 months - 6 months
  } else if (ageInMonths <= 9) {
    return "D"; // >6 months - 9 months
  } else if (ageInMonths <= 12) {
    return "E"; // >9 months - 12 months
  } else if (ageInMonths <= 18) {
    return "F"; // >12 months - 18 months
  } else if (ageInMonths <= 24) {
    return "G"; // >18 months - 24 months
  } else if (ageInMonths <= 30) {
    return "H"; // >24 months - 30 months
  } else if (ageInMonths <= 36) {
    return "I"; // >30 months - 36 months
  } else if (ageInMonths <= 48) {
    return "J"; // >36 months - 48 months
  } else if (ageInMonths <= 60) {
    return "K"; // >48 months - 60 months
  } else if (ageInMonths <= 72) {
    return "L"; // >60 months - 72 months
  } else {
    return "M"; // >72 months
  }
}

export const getAgeCategory = (months) => {
  if (months >= 0 && months <= 0.23) return "A"; // 0-7 days (approx. 0.23 months)
  if (months >= 0.24 && months <= 3) return "B"; // 8 days - 3 months
  if (months > 3 && months <= 6) return "C"; // >3 months - 6 months
  if (months > 6 && months <= 9) return "D"; // >6 months - 9 months
  if (months > 9 && months <= 12) return "E"; // >9 months - 12 months
  if (months > 12 && months <= 18) return "F"; // >12 months - 18 months
  if (months > 18 && months <= 24) return "G"; // >18 months - 24 months
  if (months > 24 && months <= 30) return "H"; // >24 months - 30 months
  if (months > 30 && months <= 36) return "I"; // >30 months - 36 months
  if (months > 36 && months <= 48) return "J"; // >36 months - 48 months
  if (months > 48 && months <= 60) return "K"; // >48 months - 60 months
  if (months > 60 && months <= 72) return "L"; // >60 months - 72 months
  if (months > 72) return "M"; // >72 months
};

  export const getAgeCategoryByDays = (days) =>{
    if (days >=0 && days <= 7) return 'A'
    if (days >=8) return 'B'
  }

  export const ageRange = {
    A: "0 - 3 month",
    B: "3 - 6 month",
    C: "6 - 9 month",
    D: "9 - 12 month",
    E: "12 - 18 month",
    F: "18 - 24 month",
    G: "24 - 36 month",
    // J: "36 - 48 month",
    // K: "48 - 60 month",
    // L: "60 - 72 month",
  };

  export  const pfdContents = {
    A: ["Whats happening 0-3 mo", "Breast Feeding", "Vaccines", "FAQs 0-3mo"],
    B: ["Whats happening 3-6mo", "FAQs 3-6", "Breast Feeding", "Vaccines"],
    C: ["Whats happening 6-9 mo", "FAQs 6-9"],
    D: ["Whats happening 9-12", "FAQs 9-12"],
    E: ["Whats happening 12-18mo", "FAQs 12-18"],
    F: ["Child Proofing", "Whats happening 18-24mo", "FAQs 18-24"],
    G: ["Whats happening 24-36 months", "FAQs 24-36","Child Proofing"],
    //J: ["Whats happening 24-36 months", "FAQs 24-36"],
    //K: ["Whats happening 24-36 months", "FAQs 24-36"],
    //L: ["Whats happening 24-36 months", "FAQs 24-36"],
  };